import { SITE_URL } from "@shared/env";

/**
 * Checks if iframe's top level window is accessible
 * If in a cross-domain situation a browser error will throw when trying
 * to access href therefore we wrap it in a boolean check.
 */
export function canAccessParentHref() {
  try {
    return Boolean(typeof window !== "undefined" && window.top?.location?.href);
  } catch (e) {
    return false;
  }
}
export function isExternalEmbed() {
  return (
    // if we cant access parent href, assume external embed
    !canAccessParentHref() ||
    // similar to getEmbeddedPurchasePlatform, if top url is not our site url, then we are not on showpass
    (canAccessParentHref() && !window?.top?.location?.href?.includes(SITE_URL))
  );
}

export function isEmbedded() {
  if (typeof window === "undefined") {
    return false;
  }
  // exclude embedded status from Cypress test environment
  if (window?.Cypress) {
    return false;
  }

  return window && window !== window?.parent;
}

export function postMessage(message: Record<string, unknown>) {
  window.parent.postMessage(message, SITE_URL);
}
